import React from "react";
import Helmet from "react-helmet";

interface Props {
  pagePath?: string;
  metaInfo: {
    metaTitle?: string;
    metaDescription?: string;
    metaKeywords?: string;
    metaCanonical?: string;
    openImage?: {
      asset: {
        url: string;
      };
    };
    twitterImage?: {
      asset: {
        url: string;
      };
    };
    twitterTitle?: string;
    openTitle?: string;
    openGraphDescription?: string;
    twitterDescription?: string;
  };
  globalMeta: {
    metaTitle?: string;
    metaDescription?: string;
    metaCanonical?: string;
    metaKeywords?: string;
    favicon?: {
      url: string;
    };
    openImage?: {
      asset: {
        url: string;
      };
    };
    twitterImage?: {
      asset: {
        url: string;
      };
    };
    twitterTitle?: string;
    openTitle?: string;
    openGraphDescription?: string;
    twitterDescription?: string;
  };
}

const SEO = ({ pagePath, metaInfo, globalMeta }: Props) => {
  const title = metaInfo?.metaTitle
    ? metaInfo?.metaTitle
    : globalMeta?.metaTitle;

  const metaDescription = metaInfo?.metaDescription
    ? metaInfo?.metaDescription
    : globalMeta?.metaDescription;

  const metaKeywords = metaInfo?.metaKeywords
    ? metaInfo?.metaKeywords
    : globalMeta?.metaKeywords;

  const twitterImage = metaInfo?.openImage
    ? metaInfo?.twitterImage
    : globalMeta?.openImage?.asset?.url;

  const ogImage = metaInfo?.openImage
    ? metaInfo?.ogImage
    : globalMeta?.openImage?.asset?.url;

  const openTitle = metaInfo?.openTitle
    ? metaInfo?.openTitle
    : globalMeta?.metaDescription;

  const openGraphDescription = metaInfo?.openGraphDescription
    ? metaInfo?.openGraphDescription
    : globalMeta?.openGraphDescription;

  const twitterTitle = metaInfo?.twitterTitle
    ? metaInfo?.twitterTitle
    : globalMeta?.openTitle;

  const twitterDescription = metaInfo?.twitterDescription
    ? metaInfo?.twitterDescription
    : globalMeta?.metaDescription;


  let selfReference = `${process.env.GATSBY_URL}${pagePath}`;

  return (
    <Helmet title={title}>
      <html lang="en" />
      {/* 
        TODO: Check which meta is actually needed.
      */}
      <meta http-equiv="Accept-CH" content="DPR, Width, Viewport-Width" />
      <meta property="og:locale" content="en_US" />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta
        property="og:url"
        content={`${process.env.GATSBY_URL}/${pagePath ? pagePath : ""}`}
      />
      <meta property="og:image" content={ogImage} />
      <meta property="og:title" content={`${openTitle}`} />
      <meta property="og:type" content="website"></meta>
      <meta property="og:site_name" content="Groove Pillow" />
      <meta property="og:description" content={openGraphDescription} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${twitterTitle}`} />
      <link rel="canonical" href={selfReference} />
      <link rel="alternate" href={`https://www.groovepillows.co.uk${pagePath}`} hreflang="en-gb" />
      <link rel="alternate" href={`https://www.groovepillows.com${pagePath}`} hreflang="en-us" />
      <link rel="alternate" href={`https://www.groovepillows.co.uk${pagePath}`} hreflang="x-default" />
      <meta name="twitter:image" content={twitterImage} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta property="twitter:domain" content={process.env.GATSBY_URL}></meta>
      <meta property="twitter:url" content={process.env.GATSBY_URL}></meta>
      <meta
        name="twitter:url"
        content={`${process.env.GATSBY_URL}/${pagePath ? pagePath : ""}`}
      />
      {globalMeta?.favicon && (
        <link
          rel="shortcut icon"
          type="image/png"
          href={globalMeta?.favicon.url}
          as="image"
          crossOrigin
        />
      )}
    {/* Start VWO Async SmartCode  */}
      <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
      <script type='text/javascript' id='vwoCode'>
         {`window._vwo_code || (function() {
          var account_id=741836,
          version=2.1,
          settings_tolerance=2000,
          hide_element='body',
          hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;',
          /* DO NOT EDIT BELOW THIS LINE */
          f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={nonce:v&&v.nonce,library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}v&&t.setAttribute('nonce',v.nonce);d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var n=this.getSettings(),i=d.createElement('script'),r=this;t=t||{};if(n){i.textContent=n;d.getElementsByTagName('head')[0].appendChild(i);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200||o.status===304){_vwo_code.addScript({text:o.responseText})}else{_vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}_vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var n=this.hide_element(),i=n?n+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var i=d.createElement('div');i.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;display: block !important;';i.setAttribute('id','_vis_opt_path_hides');i.classList.add('_vis_hide_layer');t.parentNode.insertBefore(i,t.nextSibling)}var o=window._vis_opt_url||d.URL,s='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(o)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:s})}else{this.load(s+'&x=true')}}};w._vwo_code=code;code.init();})(); `} 
      </script>
      {/* End VWO Async SmartCode  */}

    </Helmet>
  );
};

export default SEO;
